import React from 'react'
import { useTranslate } from 'react-admin'
import BigCalendar from 'react-big-calendar-like-google'
import moment from 'moment'
import 'moment/locale/th'
BigCalendar.momentLocalizer(moment)
import 'react-big-calendar-like-google/lib/css/react-big-calendar.css'
import './style.css'
import { slotInfo } from './type'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const formatDate = (date: Date): string => moment(date).format('YYYY-MM-DD HH:mm:ss')

const Calendar = ({
  selectable = true,
  onSelectSlot = (s): void => {
    console.log('slots:', s)
  },
  formats = {},
  ...props
}): JSX.Element => {
  const translate = useTranslate()
  const calendarFormats = {
    dayHeaderFormat: (date, culture, localizer) => localizer.format(date, 'DD MMMM (ddd)', culture),
    agendaDateFormat: (date, culture, localizer) => localizer.format(date, 'dd DD MMM YY', culture),
    dayRangeHeaderFormat: ({ start, end }, culture, localizer): string =>
      localizer.format(start, 'DD MMM', culture) + ' — ' + localizer.format(end, 'DD MMM', culture),
    ...formats,
  }
  return (
    <BigCalendar
      startAccessor='start'
      endAccessor='end'
      style={{ height: 700 }}
      selectable={selectable}
      messages={{
        allDay: translate('component.calendar.allDay'),
        previous: translate('component.calendar.previous'),
        next: translate('component.calendar.next'),
        today: translate('component.calendar.today'),
        month: translate('component.calendar.month'),
        week: translate('component.calendar.week'),
        day: translate('component.calendar.day'),
        agenda: translate('component.calendar.agenda'),
        date: translate('component.calendar.date'),
        time: translate('component.calendar.time'),
        event: translate('component.calendar.event'),
      }}
      formats={calendarFormats}
      onSelectSlot={(slots: slotInfo): void => {
        onSelectSlot({
          ...slots,
          // start: formatDate(slots.start),
          // end: formatDate(slots.end),
        })
      }}
      {...props}
    />
  )
}

export default React.memo(Calendar)
